var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 12.0003L14.3333 16.0003C14.8063 16.379 15.3941 16.5853 16 16.5853C16.6059 16.5853 17.1937 16.379 17.6667 16.0003L22.6667 12.0003M28 22.667V9.33366C28 8.62641 27.719 7.94814 27.219 7.44804C26.7189 6.94794 26.0406 6.66699 25.3333 6.66699H6.66667C5.95942 6.66699 5.28115 6.94794 4.78105 7.44804C4.28095 7.94814 4 8.62641 4 9.33366V22.667C4 23.3742 4.28095 24.0525 4.78105 24.5526C5.28115 25.0527 5.95942 25.3337 6.66667 25.3337H25.3333C26.0406 25.3337 26.7189 25.0527 27.219 24.5526C27.719 24.0525 28 23.3742 28 22.667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConwhite);
export default __webpack_public_path__ + "static/media/conwhite.bf1ed436b7d12def8c19a037a4e080bf.svg";
export { ForwardRef as ReactComponent };